const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_RE = /^[+\d][\d\s-]{6,}$/;

export const EMPTY_FORM = { service: "", town: "", description: "", name: "", email: "", phone: "", website: "" };

export const validate = (v) => {
  const e = {};
  if (!v.service) e.service = "Välj vilken tjänst det gäller.";
  if (!v.town) e.town = "Välj ort.";
  if (v.description.trim().length < 10) e.description = "Beskriv uppdraget med några ord (minst 10 tecken).";
  if (v.name.trim().length < 2) e.name = "Skriv ditt namn.";
  if (!v.email.trim()) e.email = "Skriv din e-postadress.";
  else if (!EMAIL_RE.test(v.email.trim())) e.email = "Kontrollera e-postadressen, t.ex. namn@foretag.se.";
  if (v.phone.trim() && !PHONE_RE.test(v.phone.trim())) e.phone = "Kontrollera telefonnumret, t.ex. 070-123 45 67.";
  return e;
};
